<template>
	<Transition
		enter-active-class="transition-all duration-400 ease-out"
		enter-from-class="opacity-0"
		enter-to-class="opacity-100"
		leave-active-class="transition-all duration-250 ease-in"
		leave-from-class="opacity-100"
		leave-to-class="opacity-0"
		appear
	>
		<section 
			v-if="isOpen"
			class="fixed z-[3002] inset-0 bg-white flex flex-col overflow-y-auto"
		>
			<Transition
				enter-active-class="transition-all duration-500 ease-out delay-100"
				enter-from-class="opacity-0 translate-y-[-20px]"
				enter-to-class="opacity-100 translate-y-0"
				appear
			>
				<header 
					v-if="isOpen"
					class="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-slate-200/80 shadow-sm"
				>
					<div class="flex items-center justify-between px-6 py-4">
						<div class="flex items-center gap-3">
							<div class="p-2 transition-transform duration-300 hover:scale-110">
								<img 
									src="/images/icons/category_search.svg" 
									alt="category search icon" 
									width="20" 
									height="20"
								/>
							</div>
							<h1 class="text-xl font-semibold text-slate-900 capitalize">
								{{ getTranslations("change category") }}
							</h1>
						</div>
						<button 
							type="button"
							@click="closeModal"
							aria-label="Close category selector"
							class="p-2 hover:bg-slate-50 rounded-xl transition-all duration-200 group cursor-pointer hover:scale-105 active:scale-95"
						>
							<img 
								src="/images/icons/close.svg" 
								alt="close" 
								width="20" 
								height="20"
								class="opacity-60 group-hover:opacity-80 transition-opacity"
							/>
						</button>
					</div>
				</header>
			</Transition>

			<main class="flex-1">
				<div class="max-w-7xl mx-auto px-6 py-8">
					<Transition
						enter-active-class="transition-all duration-600 ease-out delay-200"
						enter-from-class="opacity-0 translate-y-[30px]"
						enter-to-class="opacity-100 translate-y-0"
						appear
					>
						<div v-if="isOpen" class="text-center mb-10">
							<h2 class="text-3xl font-bold text-slate-900 mb-2 capitalize">
								{{ getTranslations("choose category") }}
							</h2>
							<p class="text-slate-600 text-lg">
								{{ getTranslations("Select a category to browse our products") }}
							</p>
						</div>
					</Transition>
					
					<Transition
						enter-active-class="transition-all duration-700 ease-out delay-300"
						enter-from-class="opacity-0 translate-y-[40px]"
						enter-to-class="opacity-100 translate-y-0"
						appear
					>
						<div v-if="isOpen">
							<CategoryGrid 
								:categories="categories" 
								:hide_label="true"
								@categorySelected="handleCategorySelected" 
							/>
						</div>
					</Transition>
				</div>
			</main>
		</section>
	</Transition>
</template>

<script lang="js" src="./CategoryModal.js"></script>